import * as React from 'react'
import { DateSeparatorSpan } from './DateSeparatorSpan'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const DateSeparatorSpanExamples = () => {
  return (
    <div className="DateSeparatorSpanExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <DateSeparatorSpan />
      </Provider>
    </div>
  )
}
